import React, { ReactElement, useState } from "react";
import { memo } from "react";
import "./Collapse.less";

type Props = {
   children: React.ReactElement;
   openHeader?: React.ReactNode;
   header?: React.ReactNode;
   headerClassName?: string;
   contentClassName?: string;
   containerClassName?: string;
   collapsible?: boolean;
   style?: React.CSSProperties;
   setCustomIsOpen?: (isOpen: (isOpen: boolean) => boolean) => void;
};

const Collapse: React.FC<Props> = ({
   children,
   style,
   openHeader,
   header,
   headerClassName,
   containerClassName,
   contentClassName,
   collapsible = true,
   setCustomIsOpen,
}) => {
   const [isOpen, setIsOpen] = useState(false);

   const handleCollapseVisibility = () => {
      setIsOpen((prevState) => !prevState);
      setCustomIsOpen && setCustomIsOpen((prevState) => !prevState);
   };

   return (
      <div style={style} className={`bp2collapse ${containerClassName ? containerClassName : ""}`}>
         <button
            className={`bp2collapse__item ${headerClassName ? headerClassName : ""}`}
            aria-expanded={isOpen && collapsible}
            onClick={handleCollapseVisibility}
         >
            {isOpen && collapsible ? (openHeader ? openHeader : header) : header}
         </button>
         {collapsible && (
            <div
               className={`bp2collapse__content ${isOpen ? "bp2collapse__content--open" : ""} ${contentClassName ? contentClassName : ""}`}
               data-testid="bp2collapse__content"
               data-is-open={isOpen}
            >
               {React.Children.map(
                  children as ReactElement<{ isCollapseOpen?: boolean }>[],
                  (child) => {
                     if (React.isValidElement(child)) {
                        return React.cloneElement(child, { isCollapseOpen: isOpen });
                     }

                     return child;
                  },
               )}
            </div>
         )}
      </div>
   );
};

export default memo(Collapse);
